<app-activate-page
  [working]="working$ | async"
  [success]="success$ | async"
  [error]="error$ | async">
</app-activate-page>